import React from "react";
import PropTypes from "prop-types";
import { StyledListItem } from "./styled";

const ListItem = ({ active, children, justifyContent, customStyle, noBoldLastChild, onClick }) => {
    return (
        <StyledListItem
            active={active}
            justifyContent={justifyContent}
            customStyle={customStyle}
            noBoldLastChild={noBoldLastChild}
            onClick={onClick}
        >
            {children}
        </StyledListItem>
    );
};

ListItem.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
    justifyContent: PropTypes.oneOf(['space-between', 'flex-end', 'flex-start']),
    customStyle: PropTypes.array,
    noBoldLastChild: PropTypes.bool,
    onClick: PropTypes.func
};

ListItem.defaultProps = {
    justifyContent: 'space-between'
};

export default React.memo(ListItem);
